/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchScansResultsEquipmentModel } from './search-scans-results-equipment-model';


export interface SearchScanResultDevice { 
    equipmentId?: string | null;
    ipAddress?: string | null;
    macAddress?: string | null;
    model?: SearchScansResultsEquipmentModel;
    rawModel?: string | null;
    firmware?: string | null;
    detectedAtUtc?: string | null;
}

